export default __webpack_public_path__ + "static/media/landing-start.3e6acf1d.jpg";